var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 103 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.871 .52)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "svg-logo-1",
    d: "M57.688 15.506A9.03 9.03 0 0 0 50.807.65H37.42v25.8h5.149v-7.744H52.1a3.872 3.872 0 0 1 0 7.744h-9.531l-5.149 5.16H52.1a9.026 9.026 0 0 0 5.588-16.1zm-6.881-1.96h-8.238V5.81h8.238a3.868 3.868 0 0 1 0 7.736z",
    transform: "translate(-37.42 -.65)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(79.308 .52)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "svg-logo-1",
    d: "M112.745.65H99.35v15.48h5.15V5.81h8.238a5.16 5.16 0 0 1 .008 10.32h-8.238l-5.149 5.16v10.32h5.149V21.29h8.238a10.32 10.32 0 0 0 0-20.64z",
    transform: "translate(-99.35 -.65)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(53.564 .52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.749)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "svg-logo-1",
    d: "M86.817.65L78.06 16.13l8.757 15.48H93l-8.753-15.48L93 .65z",
    transform: "translate(-78.06 -.65)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "svg-logo-2",
    d: "M73.279 31.61l8.757-15.48L73.279.65H67.1l8.749 15.48L67.1 31.61z",
    transform: "translate(-67.1 -.65)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "svg-logo-1",
    d: "M12.876 18.584H20.6v.52a7.727 7.727 0 1 1-15.454 0v-6.192a7.721 7.721 0 0 1 14.635-3.464l3.752-3.76A12.859 12.859 0 0 0 0 12.9v6.2a12.876 12.876 0 1 0 25.752 0v-5.68h-7.727z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.cb816fa4cd097ac1d41ef9fcf1e4ce87.svg";
export { ForwardRef as ReactComponent };